import { render, staticRenderFns } from "./ViqSidebar.vue?vue&type=template&id=6f3c9aec&scoped=true"
import script from "./ViqSidebar.vue?vue&type=script&lang=js"
export * from "./ViqSidebar.vue?vue&type=script&lang=js"
import style0 from "./ViqSidebar.vue?vue&type=style&index=0&id=6f3c9aec&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3c9aec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f3c9aec')) {
      api.createRecord('6f3c9aec', component.options)
    } else {
      api.reload('6f3c9aec', component.options)
    }
    module.hot.accept("./ViqSidebar.vue?vue&type=template&id=6f3c9aec&scoped=true", function () {
      api.rerender('6f3c9aec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/viq/ViqSidebar.vue"
export default component.exports